import React, { Component } from 'react';

import {
  Add16,
  Delete16,
  Edit16,
  Checkmark24,
  ArrowLeft20,
  Fork16,
  Home20,
  Download16,
  Document16,
} from '@carbon/icons-react';
import { getSuccess, getError, apioperation } from '../../helpers/Constants';
import { dynamic, training } from '../../helpers/api/api';
import {
  DataTable,
  Search,
  Pagination,
  Checkbox,
  DataTableSkeleton,
  DatePicker,
  DatePickerInput,
  DropdownSkeleton,
  ButtonSkeleton,
  TableContainer,
  TableToolbar,
  Button,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TextInput,
  Loading,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Breadcrumb,
  BreadcrumbItem,
  FormGroup
} from 'carbon-components-react';
import { RenderDataTableCell, NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { Online, Offline } from '../../components/common/OnLineOffLine';
//import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import SimpleReactValidator from 'simple-react-validator';
import { showNotification } from '../../helpers/notification/BaseNotification';
import moment from 'moment';
import { ComboBox } from '../../helpers/ComboBox';


const log = (type) => console.log.bind(console, type);

function handleResponse(response) {
  //if (!response.status==200) {
  //    const error = (data && data.message) || response.statusText;
  //    return Promise.reject(error);
  //}
  return response.data;
}
function getInsertSchema(sch) {
  if (sch == null) return {};
  let insertSchema = { ...sch };
  if ('definitions' in sch) {
    const def = { ...sch.definitions };
    for (var k in def) {
      if ('inUse' in def[k] && def[k]['inUse'] != null) {
        let filterEnum = {
          enum : []
        };
        for (let j = 0; j < def[k]['inUse'].length; j++) {
          if (def[k]['inUse'][j] == true) {
            let enumValue = {
              key: def[k]['enum'][j],
              text: def[k]['enumNames'][j]
            }
            filterEnum.enum.push(enumValue);

          }
        }
        insertSchema['definitions'][k] = Object.assign({}, filterEnum);
      }
    }
  }
  return insertSchema;
}

export default class EnergyEmissionJSCrud extends Component {
  constructor(props) {
    super(props);
    //this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePaging = this.handlePaging.bind(this);
    this.onCloseConfirm = this.onCloseConfirm.bind(this);
    this.setParent = this.setParent.bind(this);
    this.validator = new SimpleReactValidator({
      validators: {
        datePicker: {
          message: 'The :attribute must be a valid date with mm/dd/yyyy format',
          rule: (val, params) => moment(val).isValid() && params.indexOf(val) === -1,
          required: true, // optional
        },
      },
      locale: 'en'
    });

    this.state = {
      baseUrl: props.entity + '/',
      formData: undefined,
      originalFormData: undefined,
      insertSchema: {},
      itemList: [],
      isLoading: true,
      isLoadingSchema: true,
      isLoadingModal: true,
      isOpenModal: false,
      isEditModal: false,
      isSubmitted: false,
      isDeleting: false,
      confirmModal: false,
      idToDelete: null,
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      search: '',
      isRecursive: props.isRecursive || false,
      idParent: null,
      parentHistory: [],
      isReadOnly: props.isReadOnly || false,
      isExportLoading: false,
      showOutOfView: false

    };
  }

  componentDidMount() {

    this.getItemList();
    this.getSchema();
  }

  backToFirstParent() {
    this.setState(
      {
        idParent: null,
        parentHistory: [],
      },
      () => {
        this.getItemList();
        this.getSchema();
      }
    );
  }

  backToPrevParent() {
    const arrlength = this.state.parentHistory.length;
    if (arrlength > 1) {
      const list = this.state.parentHistory.slice(0, arrlength - 1);
      const element = list[list.length - 1];
      this.setState(
        {
          idParent: element.id,
          parentHistory: list,
        },
        () => {
          this.getItemList();
          this.getSchema();
        }
      );
    } else {
      this.backToFirstParent();
    }
  }

  setParent(id) {
    let element = this.state.itemList.find((el) => el.id == id);
    if (element != null) {
      const list = this.state.parentHistory.concat([element]);
      this.setState(
        {
          idParent: id,
          parentHistory: list,
        },
        () => {
          this.getItemList();
          this.getSchema();
        }
      );
    } else {
      showNotification.error();
    }
  }

  getSchema() {
    this.setState({
      isLoadingSchema: true,
    });

    var urlSchema = this.state.baseUrl + 'jsonschema';
    var data = {};

    if (this.state.idParent != null) {
      data = {
        params: {
          parent: this.state.idParent,
        },
      };
    }

    dynamic
      .getAll(urlSchema, data)
      .then(handleResponse)
      .then((data) => {
        var sch = JSON.parse(data);

        delete sch.$schema; //rimuovo campo non necessario dallo schema
        //imposto il depthLevel per le anagrafiche ricorsive
        if (this.state.isRecursive) {
          if (sch['properties'] && 'depthLevel' in sch['properties']) {
            sch.properties.depthLevel.default = this.state.parentHistory.length;
          }
        }

        var insSch = getInsertSchema(JSON.parse(JSON.stringify(sch)));
        this.setState({
          isLoadingSchema: false,
          insertSchema: insSch,
        });
      });
  }

  getItemList(param) {
    this.setState({ isLoading: true });

    const data = {
      params: {
        page: param != null ? param.page : this.state.currentPage,
        pageSize: param != null ? param.pageSize : this.state.pageSize,
        search: this.state.search,
        parent: this.state.idParent,
      },
    };

    dynamic
      .getAll(this.state.baseUrl, data)
      .then(handleResponse)
      .then((data) => {
        this.setState({
          isLoading: false,
          ...data,
        });
      })
      .catch((error) => {
        showNotification.error(getError(error, this.props.title, apioperation.GET));
      });
  }

  getForEdit(id) {
    this.setState({
      isEditModal: true,
      isLoadingModal: true,
      isOpenModal: true,
    });
    dynamic
      .get(this.state.baseUrl, id)
      .then(handleResponse)
      .then((data) => {
        if (this.props.nullableEnumProperty && this.props.nullableEnumProperty.length > 0) {
          for (var i = 0; i < this.props.nullableEnumProperty.length; i++) {
            var item = this.props.nullableEnumProperty[i];

            if (data.hasOwnProperty(item) && data[item] === null) {
              data[item] = undefined;
            }
          }
        }
        this.toggleShowOutOfView(this.getSelectComboItem(this.state.insertSchema.definitions?.EnergyEmittedSubstanceAsEnum.enum, data.idEnergyEmittedSubstance));
        this.setState({
          originalFormData: data,
          formData: data,
          isLoadingModal: false,
        });
      })
      .catch((error) => {
        showNotification.error(getError(error, this.props.title, apioperation.GET));
      });
  }

  confirmDelete = (id) => {
    this.setState({
      idToDelete: id,
      confirmModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm() {
    this.setState({
      confirmModal: false,
    });
  }

  confirmAlertCustom() {
    let id = this.state.idToDelete;
    if (id == null) return null;

    let element = this.state.itemList.find((el) => el.id == id);
    let nameItem = element != null ? element.code || element.name : null;
    let loading = this.state.isDeleting;
    return (
      <ComposedModal
        className="light-modal confirm-modal"
        open={this.state.confirmModal}
        onClose={this.onCloseConfirm}
      >
        <ModalHeader className="margin-modal" title={'Are you sure to delete?'} />
        <ModalBody>
          {loading && <Loading active={true} withOverlay={true} description="Deleting" />}
          <p>{nameItem}</p>
        </ModalBody>

        <ModalFooter>
          <Button kind="secondary" onClick={this.onCloseConfirm}>
            NO
          </Button>
          <Button kind="primary" onClick={() => this.deleteItem()}>
            YES
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }

  deleteItem() {
    let id = this.state.idToDelete;
    this.setState({
      isDeleting: true,
    });
    dynamic
      .delete(this.state.baseUrl, id)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            isDeleting: false,
            idToDelete: null,
          });
          this.onCloseConfirm();
          this.getItemList();
          showNotification.success(getSuccess(this.props.title, apioperation.DELETE));
        } else {
          this.setState({
            isDeleting: false,
          });
          showNotification.error();
        }
      })
      .catch((error) => {
        this.setState({
          isDeleting: false,
        });
        showNotification.error(getError(error, this.props.title, apioperation.DELETE));
      });
  }

  renderAlertModal = () => {
    const loading = this.state.isSubmitted
    return (
      <ComposedModal
      className="light-modal confirm-modal"
      open={this.state.isOpenAlertModal}
      onClose={() => this.setState({isOpenAlertModal: false})}
    >
      <ModalHeader className="margin-modal" title={'Are you sure to continue?'} />
      <ModalBody>
        {loading && <Loading active={true} withOverlay={true} description="Saving" />} 
        <p style={{margin:"20px 0px"}}>Attention in the archive there are training still in progress for this training data code. Would you like to proceed and modify the duration anyway?</p>
      </ModalBody>

      <ModalFooter>
        <Button kind="secondary" onClick={() => this.setState({isOpenAlertModal: false, isOpenModal: true})}>
          NO
        </Button>
        <Button kind="primary" onClick={() => this.submit(this.state.formData)}>
          YES
        </Button>
      </ModalFooter>
    </ComposedModal>

    )
  }



submit = (formData) => {
  if (this.validator.allValid()) {
    let datiForm = {...formData};
    this.setState({
      isSubmitted: true,
      formData: datiForm,
    });

    let urlSchema = this.state.baseUrl;
    let method = this.state.isEditModal
      ? dynamic.put(urlSchema, datiForm)
      : dynamic.post(urlSchema, datiForm);

    method
      .then((response) => {
        if (response.status == 200) {
          this.getItemList();
          this.setState({
            formData: undefined,
            isSubmitted: false,
            isOpenModal: false,
            isOpenAlertModal:false
          });
          showNotification.success(
            getSuccess(
              this.props.title,
              this.state.isEditModal ? apioperation.PUT : apioperation.POST
            )
          );
        } else {
          this.setState({
            isSubmitted: false,
            isOpenAlertModal:false
          });
          showNotification.error();
        }
      })
      .catch((error) => {
        this.setState({
          isSubmitted: false,
          isOpenAlertModal:false
        });
        showNotification.error(
          getError(
            error,
            this.props.title,
            this.state.isEditModal ? apioperation.PUT : apioperation.POST
          )
        );
      });
    }
    else
    {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  addNew() {
    this.setState({
      formData: {
          idEnergyEmittedSubstance : null,
          idEnergySourceType : null,
          idEnergyUsageType : null,
          outOfScope : null,
          coefficient : '',
          year : '',
          validSince :  null,
          validUntil : null
      },
      isEditModal: false,
      isOpenModal: true,
    });
  }

  downloadFile() {
    if (this.state.isExportLoading) return;

    this.setState({
      isExportLoading: true,
    });
    dynamic
      .getAll(this.state.baseUrl + 'excel', { responseType: 'arraybuffer' })
      .then((response) => {
        //fileDownload(new Blob([response.data]), 'report.xlsx');
        var data = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;

        var nomefile =
          'Export_' + this.props.title + '_' + moment().format('YYYYMMDDHHmmSS') + '.xlsx';
        tempLink.setAttribute('download', nomefile);

        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(getError(error, 'Download File', apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isExportLoading: false,
        });
      });
  }

  toggleModal(open) {
    this.setState({ isOpenModal: open });
  }

  handlePaging(event) {
    this.getItemList(event);
  }

  handleSearchFormSubmit = (e) => {
    e.preventDefault();
    this.getItemList({ page: 1 });
  };

  handleInputChange = (e) => {
    let val = e.target.value;
    this.setState(
      {
        search: val,
      },
      () => {
        if (val == '') {
          this.getItemList({ page: 1 });
        }
      }
    );
  };

  showLoading() {
    let show = (this.state.isEditModal && this.state.isLoadingModal) || this.state.isSubmitted;
    let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active={true} withOverlay={true} description={descr} />;
    //return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  toggleShowOutOfView = (selectedItem) => {
    this.setState((prevState) => {return {showOutOfView: (selectedItem ? (selectedItem.text === 'CO2') : false)}}); 
  }

  updateFormState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state.formData };
    statusCopy[inputName] = inputValue;

    this.setState({ formData: statusCopy });
  };

  getSelectComboItem = (arr, id) =>  {
    return (id === null ? null : (arr || []).find(item => item.key === id));
  }

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.key : null;
    this.updateFormState(inputName, inputValue, objName);
  };

  handleChangeEnergyEmittedSubstance = (inputName, selectedItem, objName) => {
    this.toggleShowOutOfView(selectedItem);
    this.handleChangeCombo(inputName, selectedItem, objName);
  }

  handleChangeValidSince(e) {
    this.setState((prevState) => {
      const statusCopy= { ...prevState.formData};
      statusCopy['validSince']= moment(e[0]).format('YYYY-MM-DD');
      return { formData:  statusCopy };
    });
  }
  
  handleChangeValidUntil(e) {
    this.setState((prevState) => {
      const statusCopy= { ...prevState.formData};
      statusCopy['validUntil']= moment(e[0]).format('YYYY-MM-DD');
      return { formData:  statusCopy };
    });
  }

  crudModal() {
    const propsC = {
      modalHeader: () => ({
        title: (this.state.isEditModal ? 'Edit ' : 'Add new ') + this.props.title,
        iconDescription: 'Close',
        buttonOnClick: () => this.toggleModal(false),
      }),
    };

    const selectedItemCombo = {
      substance: this.getSelectComboItem(this.state.insertSchema.definitions?.EnergyEmittedSubstanceAsEnum.enum, this.state.formData?.idEnergyEmittedSubstance),
      usageType: this.getSelectComboItem(this.state.insertSchema.definitions?.EnergyUsageTypeAsEnum.enum, this.state.formData?.idEnergyUsageType),
      sourceType: this.getSelectComboItem(this.state.insertSchema.definitions?.EnergySourceTypeAsEnum.enum, this.state.formData?.idEnergySourceType)
    };

    const validationsCrudModal = {
      coefficient: this.validator.message('Coefficient', this.state.formData?.coefficient, 'required'),
      year: this.validator.message('Year', this.state.formData?.year, 'required|integer'),
      validUntil: this.validator.message('validUntil', this.state.formData?.validUntil, 'required|datePicker'),
      substance: this.validator.message('Energy_Emitted_Substance', this.state.formData?.idEnergyEmittedSubstance, 'required'),
      source: this.validator.message('Energy_Source_Type', this.state.formData?.idEnergySourceType, 'required'),
    };

    return (
      <ComposedModal
        className="light-modal"
        open={this.state.isOpenModal}
        danger="false"
        //onClose={() => this.toggleModal(false)}
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" {...propsC.modalHeader()} />
        <ModalBody className="margin-modal">
          {this.showLoading()}
          <div>
            <FormGroup legendText="Energy Emitted Substance*">
              {this.state.insertSchema.definitions == null || this.state.insertSchema.definitions.EnergyEmittedSubstanceAsEnum == null ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="idEnergyEmittedSubstance"
                  placeholder="Select"
                  name="idEnergyEmittedSubstance"
                  alt="energy emitted substance"
                  onChange={this.handleChangeEnergyEmittedSubstance}
                  invalid={validationsCrudModal.substance != null}
                  selectedItem={selectedItemCombo.substance}
                  itemToString={(item) => (item ? item.text : '')}
                  items={this.state.insertSchema.definitions?.EnergyEmittedSubstanceAsEnum.enum }
                  disabled={this.state.isReadOnly}
                />
              )}
              {validationsCrudModal.substance}
            </FormGroup>
          </div>
          <div>
            <FormGroup legendText="Energy Usage Type">
              {this.state.insertSchema.definitions == null  || this.state.insertSchema.definitions?.EnergyUsageTypeAsEnum == null ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="idEnergyUsageType"
                  name="idEnergyUsageType"
                  alt="energy usage type"
                  placeholder="Select"
                  onChange={this.handleChangeCombo}
                  selectedItem={selectedItemCombo.usageType}
                  itemToString={(item) => (item ? item.text : '')}
                  items={this.state.insertSchema.definitions?.EnergyUsageTypeAsEnum.enum }
                  disabled={this.state.isReadOnly}
                />
              )}
            </FormGroup>
          </div>
          <div>
            <FormGroup legendText="Energy Source Type*">
              {this.state.insertSchema.definitions == null  || this.state.insertSchema.definitions?.EnergySourceTypeAsEnum == null  ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="idEnergySourceType"
                  placeholder="Select"
                  name="idEnergySourceType"
                  alt="energy source type"
                  onChange={this.handleChangeCombo} 
                  
                  invalid={validationsCrudModal.source != null}
                  selectedItem={selectedItemCombo.sourceType}
                  itemToString={(item) => (item ? item.text : '')}
                  items={this.state.insertSchema.definitions?.EnergySourceTypeAsEnum.enum}
                  disabled={this.state.isReadOnly}
                />
              )}
              {validationsCrudModal.source}
            </FormGroup>
          </div>
          <div >
            <FormGroup legendText="Coefficient*">
              <TextInput
                id="coefficient"
                name="coefficient"
                placeholder="Input Coefficient"
                invalid={validationsCrudModal.coefficient != null}
                value={this.state.formData?.coefficient || ''}
                onChange={(el) => this.updateFormState(el.target.id, el.target.value, el.target.name)}
                disabled={this.state.isReadOnly}
                type="number"
                labelText=""
              />
              {validationsCrudModal.coefficient}
            </FormGroup>
          </div>
          <div>
            <FormGroup legendText="Year*">
              <TextInput
                id="year"
                name="year"
                placeholder="Input Year"
                value={this.state.formData?.year || ''}
                invalid={validationsCrudModal.year != null}
                onChange={(el) => this.updateFormState(el.target.id, el.target.value, el.target.name)}
                disabled={this.state.isReadOnly}
                type="number"
                labelText=""
              />
              {validationsCrudModal.year}
            </FormGroup>
          </div>
          <div>
            <DatePicker
              dateFormat="d/m/Y"
              datePickerType="single"
              id="valid-since-date-picker"
              light
              locale="en"
              short={false}
              onChange={(e) => this.handleChangeValidSince(e)}
            >
              <DatePickerInput
                value={
                  this.state.formData?.validSince != null
                    ? moment(this.state.formData?.validSince).format('DD/MM/Y')
                    : ''
                }
                disabled={this.state.isReadOnly}
                className="some-class"
                iconDescription="Icon description"
                id="valid-since-date-picker-input-id"

                labelText="Valid Since"
                pattern="d{1,2}/d{4}"
                placeholder="dd/mm/yyyy"
                type="text"
              />
            </DatePicker>
          </div>
          <div>
            <DatePicker
              dateFormat="d/m/Y"
              datePickerType="single"
              id="valid-until-date-picker"
              light
              locale="en"
              short={false}
              onChange={(e) => this.handleChangeValidUntil(e) }
            >
              <DatePickerInput
                value={
                  this.state.formData?.validUntil != null
                    ? moment(this.state.formData?.validUntil).format('DD/MM/Y')
                    : ''
                }
                disabled={this.state.isReadOnly}
                className="some-class"
                iconDescription="Icon description"
                id="valid-until-date-picker-input-id"
                invalid={validationsCrudModal.validUntil != null}
                invalidText={validationsCrudModal.validUntil}
                labelText="Valid Until*"
                pattern="d{1,2}/d{4}"
                placeholder="dd/mm/yyyy"
                type="text"
              />
            </DatePicker>
          </div>
          <div>
            {this.state.showOutOfView === true  ? (
              <FormGroup legendText="Out of scope">
                <Checkbox
                      id="outOfScope"
                      alt="Out of Scope"
                      labelText=""
                      checked={this.state.formData?.outOfScope || false}
                      onChange={(value, id) => this.updateFormState(id, value, id)}
                    />
              </FormGroup>
            ) : ''} 
          </div>
        </ModalBody>
        {!this.state.isReadOnly && (
          <ModalFooter>
            <Button kind="secondary" onClick={() => this.toggleModal(false)}>
              Cancel
            </Button>
            <Button
              kind="primary"
              onClick={() => {
                this.submit(this.state.formData);
              }}
            >
              Save
            </Button>
          </ModalFooter>
        )}
      </ComposedModal>
    );
  }

  render() {
    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handlePaging,
    });

    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : this.state.pageSize;

    return this.props.headers ? (
      <>
        <PageBreadCrumb
          linkTo={'/backoffice' + this.props.tab}
          linkText="BackOffice"
          titleLeft={this.props.title}
        />

        <div className="mainContainer">
          {this.confirmAlertCustom()}
          {this.state.isRecursive && (
            <Breadcrumb className="levelBreadcrumb">
              <BreadcrumbItem
                className="levelicon lv-goback"
                onClick={() => this.backToPrevParent()}
              >
                <ArrowLeft20 fill="#1A3E4C" aria-label="Go Back" />
              </BreadcrumbItem>
              <BreadcrumbItem className="lv-gohome" onClick={() => this.backToFirstParent()}>
                <Home20 fill="#1A3E4C" aria-label="Level 0" />
              </BreadcrumbItem>

              {this.state.parentHistory &&
                this.state.parentHistory.map((item, index) => (
                  <BreadcrumbItem key={item.id}>
                    <span>{'level ' + index + ' - ' + (item.code || item.name)}</span>
                  </BreadcrumbItem>
                ))}
              <BreadcrumbItem>
                <span>{'level ' + this.state.parentHistory.length}</span>
              </BreadcrumbItem>
            </Breadcrumb>
          )}
          <DataTable
            //className="mainContainer"
            rows={this.state.itemList}
            headers={this.props.headers}
            zebra={false}
            compact={false}
            render={({ rows, headers, getHeaderProps, getRowProps, getTableProps }) => (
              <TableContainer className="bx--grid--full-width">
                <TableToolbar>
                  <form
                    onSubmit={this.handleSearchFormSubmit}
                    className="max-width"
                    autoComplete="off"
                  >
                    <Online>
                      {' '}
                      <Search
                        className=""
                        light
                        name=""
                        labelText="Search"
                        placeHolderText="Search"
                        id="search-1"
                        value={this.state.search}
                        onChange={this.handleInputChange}
                      />{' '}
                    </Online>
                  </form>
                  <Online>
                    <Button
                      onClick={() => this.downloadFile()}
                      className="btn-notext"
                      iconDescription=" "
                      renderIcon={Download16}
                    >
                      {!this.state.isExportLoading ? '' : <Loading></Loading>}
                    </Button>
                  </Online>
                  <Online>
                    {!this.state.isReadOnly &&
                      (this.state.isLoadingSchema ? (
                        <ButtonSkeleton />
                      ) : (
                        <Button onClick={() => this.addNew()} renderIcon={Add16}>
                          Add New
                        </Button>
                      ))}
                  </Online>
                </TableToolbar>
                {this.state.isLoading ? (
                  <DataTableSkeleton
                    headers={[]}
                    rowCount={skeletonRowCount}
                    zebra={false}
                    compact={false}
                  />
                ) : (
                  <Table>
                    <TableHead>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type == 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header}
                          </TableHeader>
                        ))}
                        <TableHeader className="align-center">Actions</TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length == 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        rows.map((row) => (
                          <TableRow {...getRowProps({ row })}>
                            {row.cells.map((cell) => (
                              <RenderDataTableCell
                                key={cell.id}
                                cell={cell}
                                header={headers.find((x) => x.key === cell.info.header)}
                              />
                            ))}

                            <TableCell
                              key={'action-' + row.id}
                              className="tableActions align-center"
                            >
                              <div>
                                <Online>
                                  {this.state.isReadOnly ? (
                                    <Button
                                      onClick={() => this.getForEdit(row.id)}
                                      size="small"
                                      renderIcon={Document16}
                                      iconDescription="Details"
                                      kind="ghost"
                                    />
                                  ) : (
                                    <>
                                      <Button
                                        onClick={() => this.getForEdit(row.id)}
                                        size="small"
                                        renderIcon={Edit16}
                                        iconDescription="Edit"
                                        kind="ghost"
                                      />
                                      <Button
                                        onClick={() => this.confirmDelete(row.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                      />
                                      {this.state.isRecursive && (
                                        <Button
                                          onClick={() => this.setParent(row.id)}
                                          size="small"
                                          renderIcon={Fork16}
                                          iconDescription="Set Parent"
                                          kind="ghost"
                                        />
                                      )}
                                    </>
                                  )}
                                </Online>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
          <div className="footer-pagination">
            <Pagination {...paginationProps()} />
          </div>
          {this.crudModal()}
          {this.renderAlertModal()}
        </div>
      </>
    ) : (
      <h1>Error for JSCrud props.headers is required</h1>
    );
  }
}
